export default __webpack_public_path__ + "static/media/info.ff2462cd.svg";